import { fillString } from '@local_modules/generic/string-template.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

import htmlTemplateIndex from './index.html'
import { context, updateView } from './update-view.js'
import { showSelectors } from './show-selectors.js'
import { activateActions } from './activate-actions.js'

import CurrenciesClient from '../../../../../server/currencies/index-client.js'
import { loadCurrenciesRates } from '../../../../helpers/app-data-loaders/load-currencies-rates.js'

/**
 *
 * @returns
 */
export async function showPageFinancialsWithConversionPgDetails (params) {
  const { containerElementId, browserAppUser, browserAppAccount } = params
  console.log('showPageFinancialsWithConversionPgDetails')

  // add allowNoAccount?: true to allow direct entity (NOT DONE)
  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  // Set full height
  document.getElementById(containerElementId).classList.add('position-absolute')
  document.getElementById(containerElementId).classList.add('top-to-bottom')

  document.title = ['Statement:', browserAppAccount.data.appAccount.name].join(' ')

  const loadedCurrenciesRates = await loadCurrenciesRates()

  context.currenciesRates = loadedCurrenciesRates.rates

  const currencies = new CurrenciesClient()
  context.currenciesRatesMap = currencies.mapRates(loadedCurrenciesRates.rates)
  context.viewDecimals = 2
  context.browserAppAccount = browserAppAccount

  showSelectors(updateView, context)

  activateActions(document.getElementById(elementId))
}
